import { SettingsAttributes } from 'core_main/api/settings/types';
import { AppState } from './types';

export const INITIAL_STATE: AppState = {
  widgetActions: {} as AppState['widgetActions'],
  isChatHidden: true,
  hideHistory: false,
  hideNewConversationButtonSettings: {
    onChatHistory: false,
    onConversationEnd: false,
  },
  hideChatIcon: false,
  parentWindowLocation: undefined,
  isMobile: false,
  showWidget: false,
  chatAvailability: undefined,
  chatSettings: {} as SettingsAttributes,
  intlDefinitions: undefined,
  navigation: {
    currentConversationId: undefined,
    page: undefined,
  } as AppState['navigation'],
  conversations: {
    data: {},
    pages: {
      next: 1,
    },
  } as AppState['conversations'],
  messages: {
    messageData: {},
  } as AppState['messages'],
  unreadCounts: {
    total: 0,
    conversations: {},
  },
  kb: {
    categories: {},
    articles: {},
    articleSearchResults: undefined,
    articleSearchInput: '',
    currentCategoryId: undefined,
    currentArticleId: undefined,
  } as AppState['kb'],
  connection: 'online',
};

export const DEFAULT_CHAT_ICON_SIZE = 60;
